import { configureStore } from "@reduxjs/toolkit";
import researchReportsReducer from "./researchReportSlice";
import uploadReducer from "./uploadSlice";
import industriesReducer from "./industrySlice";

const preloadedState = window.__INITIAL_STATE__;

export const store = configureStore({
  reducer: {
    researchReports: researchReportsReducer,
    upload: uploadReducer,
    industries: industriesReducer,
  },
  preloadedState,
  devTools: process.env.NODE_ENV !== 'production' ? {
    maxAge: 10, // Limit history to 10 actions to prevent memory leak from polling
  } : false,
});

// Clean up the global variable to prevent memory leaks
if (typeof window !== 'undefined' && window.__INITIAL_STATE__) {
  delete window.__INITIAL_STATE__;
}
